import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.scss';
import { personalFields } from './fields';

function App() {
	const [checked, setChecked] = useState(false);
	const [values, setValues] = useState({
		vorname: '',
		nachname: '',
		anschrift: '',
		ort: '',
		postleitzahl: '',
		email: '',
		telefon: '',
		stations_count: 1,
		stations_value: '',
		adressen: '',
		vorversicherung: '',
	});
	const [errors, setErrors] = useState([]);
	const [success, setSuccess] = useState(false);

	useEffect(() => {}, [errors]);
	const handleChange = (e) => {
		const target = e.target;
		setValues({ ...values, [target.name]: target.value });
	};

	const submitForm = (e) => {
		e.preventDefault();
		setErrors([]);
		const newErrors = [];
		personalFields &&
			personalFields.forEach((field) => {
				if (field.required && !values[field.name]) {
					newErrors.push(field.name);
				}
			});
		setErrors(newErrors);
		console.log(checked);
		if (!checked || errors.length) {
			return false;
		}
		axios
			.post('https://www.emover24.com/wp-json/ladestationen/v1/request', {
				data: values,
			})
			.then((response) => {
				console.log(response.data);
				setSuccess(true);
			})
			.catch((error) => {
				console.error(error.response);
			});
	};
	if (success) {
		return (
			<div className="App">
				<h1>Ihre Anfrage wurde erfolgreich verschickt.</h1>
				<div>
					Wir verarbeiten die Daten und senden Ihnen innerhalb weniger Tage ein
					verbindliches Angebot zu.
				</div>
			</div>
		);
	}
	return (
		<div className="App">
			<form onSubmit={submitForm}>
				<h3>Ihre Daten</h3>
				<div className="grid">
					{personalFields &&
						personalFields.map((field, idx) => {
							return (
								<label key={field.name}>
									{field.label}:{' '}
									<input
										className={
											errors.find((error) => error === field.name)
												? 'error'
												: null
										}
										onChange={handleChange}
										value={values[field.name] || ''}
										type={field.type}
										name={field.name}
									/>
								</label>
							);
						})}
				</div>
				<hr />
				<h3>Ihre Ladesäule</h3>
				<div className="grid">
					<label>
						Anzahl der zu versichernden Ladesäulen:
						<input
							type="number"
							name="count_stations"
							onChange={handleChange}
							value={values['count_stations'] || ''}
						/>
					</label>
					<label>
						Gesamtwert der zu versichernden Ladesäulen:
						<input
							type="number"
							name="value_stations"
							onChange={handleChange}
							value={values['value_stations'] || ''}
						/>
					</label>
					<label style={{ gridColumn: 'span 2' } || ''}>
						Bitte geben Sie die Standorte (Adressen) der Ladesäulen zeilenweise
						an:
						<textarea
							name="adressen"
							onChange={handleChange}
							value={values['adressen'] || ''}
						/>
					</label>
				</div>
				<hr />
				<h3>Informationen zur Vorversicherung</h3>
				<label style={{ gridColumn: 'span 2' }}>
					Falls Sie bereits versichert sind, geben Sie bitte hier alle
					verfügbaren Informationen (Name der Versicherung, Versicherungsnummer,
					Vorschäden etc.) an.
					<textarea
						name="vorversicherung"
						onChange={handleChange}
						value={values['vorversicherung'] || ''}
					/>
				</label>
				<hr />
				<label>
					<input
						value={checked}
						checked={checked}
						onChange={() => setChecked(!checked)}
						type="checkbox"
					></input>{' '}
					Ich akzeptiere die{' '}
					<a href="https://www.emover24.com/datenschutz/" traget="_blank">
						Datenschutzbedingungen
					</a>{' '}
					und bin damit einverstanden zum Zweck eines individuellen Angebots von
					der Schmitz Horn Treber GmbH und deren Kooperationspartnern der
					Michael Much GmbH, der KIH Kölner Industrie- und
					Handwerks-Assekuranz-Makler GmbH und der SHT Steinhardt GmbH
					kontaktiert zu werden
				</label>
				<input type="submit" value="Senden" />
				<div style={{ clear: 'both' }}></div>
			</form>
		</div>
	);
}

export default App;
